import React, { useEffect, useRef, useState } from 'react'
import { IEnquiryDetail } from '../../../models/Enquiry'
import Conditional from '../../common/Conditional'
import EnquiryDetailRow from './helpers/EnquiryDetailRow'
import '../Enquiries.css'
import { Button } from 'semantic-ui-react'
import { useHistory } from 'react-router-dom'

export interface IEnquiryDefaultDetailProps {
  data: IEnquiryDetail
}

const EnquiryDefaultDetail = (props: IEnquiryDefaultDetailProps) => {
  const mountedRef = useRef(false)
  const history = useHistory()
  const [data, setData] = useState<IEnquiryDetail>()

  useEffect(() => {
    mountedRef.current = true
    if (mountedRef.current) {
      setData(props.data)
    }
    return () => {
      mountedRef.current = false
    }
  }, [props.data])

  const backtoEnquiries = () => {
    history.push('/my-account/enquiries')
  }

  return (
    <Conditional if={data}>
      <h2>Enquiry details</h2>
      <h3>Enquiry id: {data?.number}</h3>
      <div className="table-wrapper">
        <table>
          <thead>
            <tr>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <EnquiryDetailRow
              title="Status"
              value={data?.status}
              showDefaultAnswer={false}
            />
            <EnquiryDetailRow
              title="Customer reference number (CRN)"
              value={data?.crn}
              showDefaultAnswer={false}
            />
            <EnquiryDetailRow
              title="Enquiry type level 2"
              value={data?.enquiryTypeLevel2}
              showDefaultAnswer={false}
            />
            <EnquiryDetailRow
              title="Channel"
              value={data?.channel}
              showDefaultAnswer={false}
            />
          </tbody>
          <tfoot></tfoot>
        </table>
      </div>
      <Button className="is-primary" onClick={() => backtoEnquiries()}>
        Return to enquiry list
      </Button>
    </Conditional>
  )
}
export default EnquiryDefaultDetail
